import { forEachRowEl } from './row-dom-registry'
import { resolveRowDomId } from './sync-current-row-dom'
import type { DataGrid } from '../types'

export const HOVER_ROW_CLASS = 'is-hover'

export function setHoverRowDom(
  $grid: DataGrid,
  row: Record<string, unknown>
) {
  clearHoverRowDom($grid)
  const rowId = resolveRowDomId($grid, row)
  if (!rowId) {
    return
  }
  forEachRowEl($grid, rowId, (el) => {
    el.classList.add(HOVER_ROW_CLASS)
  })
  $grid.internalData.hoverRowId = rowId
}

export function clearHoverRowDom($grid: DataGrid) {
  const root = $grid.bodyRef?.value
  if (root) {
    root.querySelectorAll(`.z-grid__row.${HOVER_ROW_CLASS}`).forEach((el) => {
      el.classList.remove(HOVER_ROW_CLASS)
    })
  }
  $grid.internalData.hoverRowId = null
}
